import {Injectable} from '@angular/core';
import {ApiService, LOCALE_CONFIG} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class ProductsService {

    constructor(private api: ApiService) {
    }

    getList(locale: string = LOCALE_CONFIG.DEFAULT_LOCALE) {
        return this.api.get(`/admin/products/${locale}`).pipe(map(({result}) => result));
    }

    update(data, locale: string = LOCALE_CONFIG.DEFAULT_LOCALE) {
        return this.api.put(`/admin/products/${locale}`, data).pipe(map(({result}) => result));
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/products.service.ts